import { merge } from "lodash";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {
  ICloudDetailsSample,
  ICloudDetailsXref,
  IDateSeen,
  IInitialData
} from "../@types/expanded_cloud_details";
import { sampleReportKeys } from "../queryKeys";
import api from "../services/api";
import { ErrorResponse, MessageErrorResponse } from "../../../requests/@types";

interface IGetExpandedCloudDetails {
  sample: ICloudDetailsSample & IDateSeen;
  xref: ICloudDetailsXref;
}

const useGetExpandedCloudDetails = (
  hash: string,
  initialData?: IInitialData
): UseQueryResult<
  IGetExpandedCloudDetails,
  ErrorResponse<MessageErrorResponse>
> =>
  useQuery({
    queryKey: sampleReportKeys.expandedDetailsCloud(hash),
    queryFn: () => api.getExpandedCloudDetails(hash),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    select: ({ data }) => merge(data, initialData)
  });

export default useGetExpandedCloudDetails;
